export class ConfiguracionMostrarToast {
    notificarOK?: boolean = false;
    notificarError?: boolean = true;
    mensajeOK?: string = 'toast.cambios.guardados.exito';
    mensajeError?: string = 'toast.cambios.guardados.error';
}
